module.exports = {
    RECEIVE_DOCUMENTS_PICTURES: 'RECEIVE_DOCUMENTS_PICTURES',
    RECEIVE_DOCUMENTS_FILES: 'RECEIVE_DOCUMENTS_FILES',
    PDF_EXTENSIONS: ['pdf', 'PDF'],
    PICTURE: 'picture',
    DOCUMENT: 'document',
}
